exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*------- Prelaoder --------*/\n#preloader {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #fff;\n  z-index: 99;\n}\n\n#status {\n  width: 200px;\n  height: 200px;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  background-image: url(/images/preloader.gif);\n  background-repeat: no-repeat;\n  background-position: center;\n  margin: -100px 0 0 -100px;\n}", ""]);

// exports
